module.exports = __webpack_public_path__ + "img/cover-uu.0a3d6a64.jpg";